import { css } from '@microsoft/fast-element';
export const foundationToastStyles = css `
  @keyframes append-animate {
    from {
      transform: translateX(100%);
      opacity: 0%;
    }

    to {
      transform: translateX(0%);
      opacity: 100%;
    }
  }

  @keyframes delete-animate {
    from {
      transform: translateX(0%);
      opacity: 100%;
    }

    to {
      transform: translateX(100%);
      opacity: 0%;
    }
  }

  :host {
    --toast-min-width: 356px;
    --toast-min-height: 128px;
    --toast-max-width: 356px;
    --toast-max-height: 272px;
  }

  .toast {
    animation: append-animate 0.3s linear;
    max-width: var(--toast-max-width);
    min-width: var(--toast-min-width);
    background-color: var(--fill-color);
    border-radius: calc(var(--control-corner-radius) * 1px);
    border-width: thin;
    border-color: var(--neutral-fill-rest);
    box-shadow: 0 2px 15px 0 rgb(0 0 0 / 35%);
    display: flex;
    position: relative;
    flex-direction: row;
    padding: 8px 8px 8px 15px;
    margin: 5px;
  }

  .toast-delete {
    animation: delete-animate 0.3s linear;
    opacity: 0%;
  }

  .toast::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 5px;
    height: calc(100% - 10px);
    width: 4px;
    border-radius: 2px;
    background-color: red;
  }

  .content-wrapper {
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
  }

  .bottom {
    width: 70%;
  }

  .top {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .content {
    width: 85%;
    font-size: 12px;
    overflow-wrap: break-word;
  }

  .date {
    color: var(--neutral-foreground-hint);
    font-size: 12px;
    margin: 0 0 5px;
  }

  .close-icon svg {
    cursor: pointer;
  }
`;
